var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicatorMgt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.629 1.972a3.106 3.106 0 013.102 2.925l.005.183v9.785a3.106 3.106 0 01-2.925 3.102l-.182.005H4.843a3.106 3.106 0 01-3.102-2.924l-.005-.183v-.68a.64.64 0 011.272-.105l.008.105v.68c0 .957.734 1.74 1.67 1.82l.157.007h9.786c.957 0 1.74-.734 1.82-1.669l.007-.158V5.08c0-.957-.734-1.741-1.67-1.821l-.157-.007H4.843c-.957 0-1.74.734-1.82 1.67l-.007.158V8.59a.64.64 0 01-1.271.103l-.009-.103V5.08a3.106 3.106 0 012.925-3.102l.182-.006h9.786zm-.388 4.724c.268-.063.512.167.443.418l-.789 2.86c-.068.253-.406.343-.608.16l-.682-.608-3.431 3.1a.703.703 0 01-.47.176.698.698 0 01-.477-.184l-2.679-2.492-2.56 2.247a.71.71 0 01-.956-.027.604.604 0 01.03-.893l3.037-2.667a.715.715 0 01.941.014l2.67 2.485 2.918-2.634-.711-.638c-.208-.188-.114-.516.165-.581l3.159-.736z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorMgt);
export default __webpack_public_path__ + "static/assets/indicatorMgt.38d04e1b.svg";
export { ForwardRef as ReactComponent };